module.exports = __webpack_public_path__ + "media/country_flags/sl-a438473a.png";